import React, { Component, useEffect } from 'react';
import '../standard16/css_16/userCertificate.css';
import NavBar from "../NavBar";
import Footer from "../Footer";
import Web3 from 'web3';
import standard_abi from '../../abis/Standard8Owner-abi.json';
import i18n from '../I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { properties } from '../properties.js';
import QRCode from "react-qr-code";
import Cookies from 'js-cookie';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { checkFileType, logout, apiSecuredRequest, cambiarIdioma, isUserOrWallet, setBearer} from '../functions.js';


class NftDisplay extends Component {

	async componentDidMount() {
		// 1. Carga de Web3
		const bearer =  await this.checkIfWeb3UserOrLoginUser()
		// 2. Carga de datos de la Blockchain
		this.loadCertificate(bearer);
		// 3. Carga los nfts del usuario
	}


	cambiarIdioma = (idioma) => {
        const { i18n } = this.props;
        i18n.changeLanguage(idioma); 
		Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
    };

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

	async checkIfWeb3UserOrLoginUser(){
        let params = (new URL(document.location)).searchParams;
		const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})
        
        let empresaIdVar;
       
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        const email = Cookies.get("email");
		const userId = Cookies.get("userId");
		this.setState({userId})
        this.setState({ email: email });
        bearerVar = Cookies.get("id");
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        
        let account = await isUserOrWallet(email, bearerVar);
		this.setState({account: account});
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
       
       

       
        return bearerVar;
       
    }

	async verificarPrimaryKey(bearer) {

		try{
			let user;
			let nombre;
			let apellido1;
			let apellido2;
			let documento;
			let email;
			let addressCheck;


				if(this.state.account != 0) {
					let data = JSON.stringify({
						walletDir: `${this.state.account}`,
						
					  });
					addressCheck = this.state.account;
					this.setState({addressCheck});
					user = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUserByWalletDir`, data, bearer);
					

				}else{
					let data = JSON.stringify({
						"email": this.state.email
					  });
					addressCheck = properties.proofUHostWallet
					this.setState({addressCheck});
					user = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUser`, data, bearer);

				}

					nombre = user.data.nombre;
					apellido1 = user.data.apellido1;
					apellido2 = user.data.apellido2;
					documento = user.data.documento;
					this.setState({documento});
					email = user.data.email;

					const hashValidation = await this.state.contractA.methods.checkUserInfo(nombre, apellido1, apellido2, email, documento, 
						this.state.nftSeleccionado.campoNumerico,
						this.state.nftSeleccionado.modelo,
						this.state.nftSeleccionado.idProducto).call({ from: this.state.addressCheck })

					if (hashValidation == false) {
						Swal.fire({
							icon: 'error',
							title: '¡Incorrect!',
							text: 'The information does not match with the certificate. Try again or contact support.',
							confirmButtonColor: '#196CF6',
							confirmButtonText: 'Try Again'
						})
					} else {

						this.setState({ nombre })
						this.setState({ apellido1 })
						this.setState({ apellido2 })
						this.setState({ certEmail: email })
						this.setState({ show: false })
						Swal.fire({
							title: 'Information provided has been correctly validated.',
							titleColor: '#FF0000',
							icon: 'success',
							confirmButtonColor: '#2B4570',
							confirmButtonText: 'Close',
						})
					}

		} catch (err) {
			this.setState({ errorMessage: err })
		} finally {
			this.setState({ loading: false })
		}
	}


	// 1. Carga de Web3
	

	// 2. Carga de datos de la Blockchain
	async loadCertificate(bearer) {

		let camposData = JSON.stringify({
			"certificadoId": `${this.state.certificadoId}`,
			"tipoStandard": `8CAMPOS`
		});


		const campos = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/campo/getCampos`, camposData, bearer);
		this.setState({ campos: campos.data })
	
		let web3;
		
		let params = (new URL(document.location)).searchParams;
		const abi = standard_abi
        
		const certificado = JSON.parse(Cookies.get("certificado"));
        const direccion = certificado.direccion;
		let ercIdVar;
		let nftSeleccionadoVar;

		if(abi && direccion) {
			
			try{
				
				if(this.state.account != 0) {
					web3 = window.web3;
					const contractA = new web3.eth.Contract(abi, direccion);
					this.setState({ contractA: contractA })

					// METAMASK
					const networkId = await web3.eth.net.getId();
					
					const idProducto = params.get("idProducto")
					ercIdVar = params.get("ercId") !== undefined ? params.get("ercId") : null;

					 nftSeleccionadoVar = {
						id: ercIdVar,
						idProducto: params.get("idProducto"),
						modelo: params.get("itemModel"),
						descripcion: params.get("descripcion"),
						campoNumerico: params.get("campoNumerico"),
						userAddress: `${properties.proofUHostWallet}`,
						userInfo: params.get("userInfo"),
						campoFecha: params.get("campoFecha"),
						tokenUri: params.get("uri")
					}

					this.setState({ nftSeleccionado: nftSeleccionadoVar })


				}else{

					
					 web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
					 const contractA = new web3.eth.Contract(abi, direccion);
					 this.setState({contractA});
					 ercIdVar = params.get("ercId") !== undefined ? params.get("ercId") : null;
					
					//LOG IN
					nftSeleccionadoVar = {
						id: ercIdVar,
						idProducto: params.get("idProducto"),
						modelo: params.get("itemModel"),
						descripcion: params.get("descripcion"),
						userAddress: `${properties.proofUHostWallet}`,
						campoNumerico: params.get("campoNumerico"),
						userInfo: params.get("userInfo"),
						campoFecha: params.get("campoFecha"),
						tokenUri: params.get("uri")
					}

					this.setState({ nftSeleccionado: nftSeleccionadoVar })

				}

				let tipoArchivo1 = await checkFileType(nftSeleccionadoVar.tokenUri);
				this.setState({tipoArchivo1});

				this.verificarPrimaryKey(bearer);


			}catch (err) {
				this.setState({ errorMessage: err })
			}
		}else{
			Swal.fire({
				title: `${i18n.t('certificatesError')}`,
				icon: 'error',
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "OK"
				}).then((result) => {
					if (result.isConfirmed) {
						window.locationbar.href = "/"
					}else  if(result.dismiss){
						window.locationbar.href = "/"
					}
				 
				})
			  window.locationbar.href = "/"
			

		}

		

		this.setState({loading: false});

	}

	async generateQRCertificate() {
		// QR for quick validation generation
		const QRValidationUrl = `${window.location.origin}/${this.state.empresaMapping}/standard8/QRValidation?nombre=${this.state.nombre}` +
			`&apellido1=${this.state.apellido1}&apellido2=${this.state.apellido2}&email=${this.state.certEmail}` +
			`&idProducto=${this.state.nftSeleccionado.idProducto}&account=${this.state.addressCheck}` +
			`&documento=${this.state.documento}&certificadoId=${this.state.certificadoId}`
		this.setState({ qrUrl: QRValidationUrl })
	}

	constructor(props) {
		super(props)
		this.state = {
			account: '0x0',
			nftSeleccionado: null,
			loading: true,
			contractA: null,
			contractB: null,
			tipoArchivo1: null,
			balance: null,
			userNfts: null,
			email: null,
			certEmail: null,
			nombre: null,
			apellido1: null,
			apellido2: null,
			userId: null,
			bearer: null,
			campos: null,
			certificadoId: null,
			addressCheck: null,
			certificadoName: null,
			dataBapostgreNfts: null,
			empresaMapping: null,
			qrUrl: ""
		}
	}

	render() {
		const userNft = this.state.nftSeleccionado;

		//PANTALLA DE FALLO

		if (this.state.loading == true) {

			return (
				<>

					<NavBar mail = {this.state.email} bearer = {this.state.bearer} logout = {this.logout} cambiarIdioma={this.cambiarIdioma}/>
					<button onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="product_btn_validate">Back to certificates</button>

					<div className="product_content_1">

						<h1>Loading</h1>

						<Footer />
					</div>
				</>
			);
		} else {
			if (this.state.campos != null) {

				const campoNumerico = this.state.campos.filter(campo => campo.orden == "NUMERICO")[0].nombreCampo;
				const campoFecha = this.state.campos.filter(campo => campo.orden == "FECHA")[0].nombreCampo;
				const idProducto = this.state.campos.filter(campo => campo.orden == "IDPRODUCTO")[0].nombreCampo;

				//PANTALLA 3 UNA VEZ VALIDADO EL CERTIFICADO (2 opciones)
				if (this.state.nombre != null && this.state.apellido1 != null && this.state.apellido2 != null && this.state.certEmail != null) {

					if (this.state.qrUrl == "") {
						return (
							<>

									<NavBar mail={this.state.userMail} bearer={this.state.bearer} logout={this.logout} />

							<div className="nft_display_16">

								<p onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard8/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="menu_brandName_16"><span>{this.state.empresaName} /</span>
									<button onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard8/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="allBrands_btn_16">{i18n.t('AllCertificates')}</button></p>

								<div className="nftDisplay_imgItem_16">
									
										<div>
											<img src={this.state.tipoArchivo1} width="250px" alt="NFT 1" />
										</div>
									
								</div>

								<div className="content_info_16">

									<p className="product_model_16">{userNft.modelo}</p>
									

									<div className="details_container_16">
										<div className="certificateData_card_1">
											<p className="titleCard_16">{i18n.t('CertificateData')}</p>
											<table className="productDetails_table_16">
												
													<tr>
														<th className="details_th_16">{i18n.t('Name')}:</th>
														<td className="details_td_16">{this.state.nombre}</td>
													</tr>
													<tr>
														<th className="details_th_16">{i18n.t('Surname')}:</th>
														<td className="details_td_16">{this.state.apellido1}&nbsp;{this.state.apellido2}</td>
													</tr>

													<tr>
														<th className="details_th_16">{i18n.t('Email')}:</th>
														<td className="details_td_16">{this.state.certEmail}</td>
													</tr>
													<tr>
														<th className="details_th_16">{i18n.t('documento')}:</th>
														<td className="details_td_16">{this.state.documento}</td>
													</tr>
													<tr>
														<th className="details_th_16">{i18n.t('WalletAddress')}:</th>
														<td className="details_td_16"><a className="product_walletAdress_16" href='https://etherscan.io/address/${account}'>{userNft.userAddress}</a></td>
													</tr>
													<tr>
														<th className="details_th_16">{i18n.t('UserHash')}</th>
														<td className="details_td_16">{userNft.userInfo}</td>
													</tr>
													<tr>
													<th className="details_th_16">{i18n.t('model')}</th>
													<td className="details_td_16">{userNft.modelo}</td>
												</tr>

												<tr>
													<th className="details_th_16">{idProducto}</th>
													<td className="details_td_16">{userNft.idProducto}</td>
												</tr>
												<tr>
													<th className="details_th_16">{campoFecha}</th>
													<td className="details_td_16">{userNft.campoFecha}</td>
												</tr>
												<tr>
													<th className="details_th_16">{campoNumerico}</th>
													<td className="details_td_16">{userNft.campoNumerico}</td>
												</tr>
											</table>
										</div>
									</div>

									<div className="description_container_16">
										<p className="titleCard_16">DESCRIPTION</p>
										<p class="product_description_16">{userNft.descripcion}</p>
									</div>
									<div className="cewy_nftDisplay_imgItem">
                                    <button type="submit" className="cewy_homePage_emailBtn" onClick={(event) => { this.generateQRCertificate() }}>
                                        Generate QR
                                    </button>
                                    </div>
								</div>
							</div>

							<Footer />
							</>
						);

					} else {
						return (
							<>
								<NavBar mail = {this.state.email} bearer = {this.state.bearer} logout = {this.logout} cambiarIdioma={this.cambiarIdioma}/>

								<div className="certificateDisplay_16">

									<div className="qrDisplay">

										<button onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard8/userCertificateList?certificadoId=${this.state.certificadoId}&empresaName=${this.state.empresaName}` }} className="certificateDisplay_closeBtn">x</button>

										<p className="certificateDisplay_disclaimer"> {i18n.t('ScanQRValidate')}</p>

										<div className="certificate_qr">
											<QRCode value={this.state.qrUrl} />
											<h1>{userNft.modelo}</h1>
											<h1>{userNft.campoFecha}</h1>
										</div>
									</div>
								</div>
								<Footer />
							</>
						);
					}
				} 
			}
		}
	}
}


export default withTranslation()(NftDisplay);
